import React from 'react'

import {FavouriteBtn} from '@/src/features/catalog/add-to-favourite'

import {ProductListItem} from './product-list-item'
import {ProductsList} from './products-list'
import {Info} from '@/src/shared/ui/info'
import {Product} from '@/src/core/domain/entities/product'
import {getInjection} from '@runlab/di'
import {ProductListItemProvider} from './product-list-item.provider'

export const CatalogProductsList = ({products}: {products: Product[]}) => {
  return (
    <>
      <ProductsList>
        {products.length > 0 ? (
          products.map(product => <ProductListItemContainer key={product.id} product={product} />)
        ) : (
          <Info>Товары не найдены</Info>
        )}
      </ProductsList>
    </>
  )
}

const ProductListItemContainer = ({product}: {product: Product}) => {
  const productListItemVM = getInjection('ProductListItemViewModelFactory')(product)

  return (
    <ProductListItemProvider product={product}>
      <ProductListItem
        productListItemVM={productListItemVM}
        key={product.id}
        badges={<FavouriteBtn productId={product.id} />}
        actionsMobile={<FavouriteBtn productId={product.id} />}
      />
    </ProductListItemProvider>
  )
}
